<section class="feature-page">
  <app-page-header title="Todos los miembros" subtitle="Administrá los miembros activos y eliminados lógicamente."></app-page-header>
  <div class="feature-page__content">
    <mat-card class="table-surface-card">
      <mat-card-content>
        <p *ngIf="error" class="error-message">{{ error }}</p>
        <app-table-surface
          tableId="admin-member-list"
          title="Todos los miembros"
          titleIcon="manage_accounts"
          primaryActionLabel="Nuevo"
          (primaryActionClick)="createNew()"
          [enableSearch]="true"
          searchPlaceholder="Buscar por nombre, ADM o documento..."
          [enableFilter]="true"
          [enableColumnVisibility]="true"
          [showPageSizeSelector]="true"
          [pageSizeOptions]="[10, 25, 50, 100]"
          [activeFilters]="activeFilters"
          (filterRemove)="removeFilter($event)"
          (searchChange)="search($event)"
          (pageSizeChange)="changePageSize($event.pageSize)"
          [columns]="columns"
          [data]="people"
          [isLoading]="loading"
          [paginationConfig]="paginationConfig"
          [cellTemplate]="cellTemplate"
          [headerTemplate]="headerTemplate"
          [enableDensity]="true"
          noDataMessage="No hay miembros para mostrar."
          (pageChange)="changePage($event.page)">
          <div filterPanel class="member-filter-panel">
            <div class="member-filter-field">
              <span id="member-status-label" class="member-filter-label">Estado</span>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-select aria-labelledby="member-status-label" [(ngModel)]="deletionFilter" (selectionChange)="onDeletionFilterChanged()">
                  <mat-option value="all">Todos</mat-option>
                  <mat-option value="false">Activos</mat-option>
                  <mat-option value="true">Eliminados</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <app-unit-selector
              label="Unidad"
              floatLabel="always"
              placeholder="Buscar unidad..."
              [required]="false"
              [ngModel]="selectedUnit?.id ?? null"
              (unitChange)="onUnitChanged($event)">
            </app-unit-selector>
          </div>
          <div toolbarActions class="member-toolbar-actions">
            <button mat-icon-button type="button"
              [disabled]="!selectedLogicalIds.size || loading || !!busyPersonId"
              [matTooltip]="'Borrar lógicamente (' + selectedLogicalIds.size + ')'"
              [attr.aria-label]="'Borrar lógicamente ' + selectedLogicalIds.size + ' miembros seleccionados'"
              (click)="deleteSelectedLogically()">
              <mat-icon>delete</mat-icon>
            </button>
            <button mat-icon-button type="button"
              [disabled]="!selectedCount || loading || !!busyPersonId"
              [matTooltip]="'Borrado físico (' + selectedCount + ')'"
              [attr.aria-label]="'Eliminar definitivamente ' + selectedCount + ' miembros seleccionados'"
              (click)="permanentlyDeleteSelected()">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
          <ng-template #headerTemplate let-column="column" let-header="header">
            <mat-checkbox *ngIf="column === 'selection'; else columnHeader"
              [checked]="allSelectableOnPageSelected"
              [indeterminate]="selectedOnPageCount > 0 && !allSelectableOnPageSelected"
              (click)="$event.stopPropagation()"
              (change)="togglePageSelection($event.checked)"
              aria-label="Seleccionar todos los miembros de esta página">
            </mat-checkbox>
            <ng-template #columnHeader><span>{{ header }}</span></ng-template>
          </ng-template>
          <ng-template #cellTemplate let-person="row" let-column="column">
            <ng-container [ngSwitch]="column">
              <mat-checkbox *ngSwitchCase="'selection'"
                [checked]="isSelected(person)"
                (click)="$event.stopPropagation()"
                (change)="togglePersonSelection(person, $event.checked)"
                [attr.aria-label]="'Seleccionar ' + person.firstName + ' ' + person.lastName">
              </mat-checkbox>
              <span *ngSwitchCase="'name'">{{ person.lastName }}, {{ person.firstName }}</span>
              <span *ngSwitchCase="'portalMemberId'">{{ person.portalMemberId || '—' }}</span>
              <span *ngSwitchCase="'documentNumber'">{{ person.documentNumber || '—' }}</span>
              <span *ngSwitchCase="'membershipUnitName'">{{ person.membershipUnitName || '—' }}</span>
              <span *ngSwitchCase="'status'">{{ person.isMerged ? 'Fusionado' : person.isDeleted ? 'Eliminado' : 'Activo' }}</span>
              <span *ngSwitchCase="'lastModifiedAtUtc'">{{ person.lastModifiedAtUtc ? (person.lastModifiedAtUtc | date:'dd/MM/yyyy HH:mm') : '—' }}</span>
              <div *ngSwitchCase="'actions'" class="table-actions" (click)="$event.stopPropagation()">
                <button mat-icon-button matTooltip="Ver ficha del miembro" [attr.aria-label]="'Ver ficha de ' + person.firstName + ' ' + person.lastName" type="button" (click)="viewProfile(person)"><mat-icon>person</mat-icon></button>
                <button *ngIf="!person.isDeleted && !person.isMerged" mat-icon-button matTooltip="Editar" aria-label="Editar" type="button" (click)="edit(person)"><mat-icon>edit</mat-icon></button>
                <button *ngIf="person.isDeleted" mat-icon-button matTooltip="Restaurar" aria-label="Restaurar" type="button" [disabled]="busyPersonId === person.id" (click)="restore(person)"><mat-icon>restore_from_trash</mat-icon></button>
                <button *ngIf="!person.isDeleted && !person.isMerged" mat-icon-button matTooltip="Borrar" aria-label="Borrar" color="warn" type="button" [disabled]="busyPersonId === person.id" (click)="delete(person)"><mat-icon>delete</mat-icon></button>
                <button mat-icon-button matTooltip="Borrado físico" aria-label="Borrado físico" color="warn" type="button" [disabled]="busyPersonId === person.id" (click)="permanentlyDelete(person)"><mat-icon>delete_forever</mat-icon></button>
              </div>
            </ng-container>
          </ng-template>
        </app-table-surface>
      </mat-card-content>
    </mat-card>
  </div>
</section>
